import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { toast } from "react-toastify";
import { useParams, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import UsedInBadge from "../UsedInBadge";
import HelpButton from "../../../HelpContent/HelpButton";
import {
  deleteMessageTeplate,
  selectMessageTemplates,
} from "../../../store/slices/projectSlice";
import { faMinus, faPlus } from "@fortawesome/free-solid-svg-icons";
import SidebarScroll from "./SidebarScroll";
import SidebarCollapseButton from "./SidebarCollapseButton";

export default function MessageTemplatesList() {
  const params = useParams();
  const dispatch = useDispatch();
  const messageTemplates = useSelector(selectMessageTemplates);
  const [collapsed, setCollapsed] = React.useState(false);

  return (
    <div className="mt-2 card">
      <div className="card-header m-0 p-2 d-flex align-items-start">
        <h5 className="card-title">Message templates</h5>
        <HelpButton helpKey="components-message-templates" />
        <div className="flex-grow-1" />
        <Link
          to={`/library/logic/builder/${params.projectID}/message-template/create_new`}
          className="btn btn-outline-primary btn-sm border-0"
        >
          <FontAwesomeIcon icon={faPlus} />
        </Link>
        <SidebarCollapseButton
          collapsed={collapsed}
          onClick={() => setCollapsed((value) => !value)}
        />
      </div>
      {!collapsed && (
        <div className="card-body p-0">
          {messageTemplates.length > 0 ? (
            <SidebarScroll>
              <ul className="list-group list-group-flush">
                {messageTemplates.map((message) => (
                  <li
                    key={message.UUID}
                    className="list-group-item p-2 d-flex justify-content-between align-items-center"
                  >
                    <Link
                      to={`/library/logic/builder/${params.projectID}/message-template/${message.UUID}`}
                    >
                      <span title={message.Text}>{message.Label}</span>
                    </Link>

                    <UsedInBadge
                      arg={message}
                      alt={
                        // eslint-disable-next-line jsx-a11y/control-has-associated-label
                        <button
                          type="button"
                          className="btn btn-outline-danger btn-sm border-0"
                          onClick={() => {
                            dispatch(deleteMessageTeplate(message.UUID));
                            toast.success("Message deleted");
                          }}
                          title="Delete message"
                        >
                          <FontAwesomeIcon icon={faMinus} />
                        </button>
                      }
                    />
                  </li>
                ))}
              </ul>
            </SidebarScroll>
          ) : (
            <div className="text-center m-1">No message templates</div>
          )}
        </div>
      )}
    </div>
  );
}
